module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh":{"personal":"个人云"},"en":{"personal":"Personal"},"fr":{"personal":"Cloud personnel"},"de":{"personal":"Persönliche Cloud"},"jp":{"personal":"個人雲"},"es":{"personal":"Nube personal"},"pt":{"personal":"Nuvem pessoal"},"it":{"personal":"Cloud personale"},"tw":{"personal":"個人云"},"kr":{"personal":"개인 클라우드"}}')
  delete Component.options._Ctor
}
